import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import getHtmlDataSet from 'Utils/GetHtmlDataSet';
import { ToastContainer } from 'react-toastify';

import ContactUsPage from 'Screens/ContactUs/Common/Components/ContactUsPage';
import CourseBodyPage from 'Screens/CourseBody/Common/Containers/CourseBodyPage';
import CoursesListPage from 'Screens/CoursesList/Common/Containers/CoursesListPage';
import ConceptPage from 'Screens/Concept/Common/Containers/ConceptPage';
import LandingPage from 'Screens/LandingPage/Common/Components/LandingPage';
import LoginPage from 'Screens/Login/Common/Components/LoginPage';
import MissionPage from 'Screens/Mission/Common/Components/MissionPage';
import NotFound from 'Screens/NotFound/Common/Components/NotFound';
import PublicCoursesPage from 'Screens/PublicCourses/Common/Containers/PublicCoursesPage';
import Layout from 'Screens/Layout';

// const Layout = React.lazy(() => import('Screens/Layout'));
// const ContactUsPage = React.lazy(() => import('Screens/ContactUs/Common/Components/ContactUsPage'));
// const CourseBodyPage = React.lazy(() => import('Screens/CourseBody/Common/Containers/CourseBodyPage'));
// const CoursesListPage = React.lazy(() => import('Screens/CoursesList/Common/Containers/CoursesListPage'));
// const ConceptPage = React.lazy(() => import('Screens/Concept/Common/Containers/ConceptPage'));
// const LandingPage = React.lazy(() => import('Screens/LandingPage/Common/Components/LandingPage'));
// const LoginPage = React.lazy(() => import('Screens/Login/Common/Components/LoginPage'));
// const MissionPage = React.lazy(() => import('Screens/Mission/Common/Components/MissionPage'));
// const NotFound = React.lazy(() => import('Screens/NotFound/Common/Components/NotFound'));
// const PublicCoursesPage = React.lazy(() => import('Screens/PublicCourses/Common/Containers/PublicCoursesPage'));


const isLoggedIn = getHtmlDataSet().mode;

export const routes = (
    <Layout>
        <ToastContainer />
        {/* <React.Suspense fallback={<div>Loading...</div>}> */}
        {!isLoggedIn ? (
            <Switch>
                <Route path='/frontend' exact component={LandingPage} />
                <Route path='/frontend/login' exact component={LoginPage} />
                <Route path='/frontend/courseware/' exact component={PublicCoursesPage} />
                <Redirect to='/frontend/login' />
            </Switch>)
            : (
                <Switch>
                    <Route path='/frontend/mission' exact component={MissionPage} />
                    <Route path='/frontend/contact' exact component={ContactUsPage} />
                    <Route path='/frontend/courseware/' exact component={PublicCoursesPage} />
                    <Route path='/frontend/courseware/courseslist' exact component={CoursesListPage} />
                    <Route path='/frontend/courseware/course/:courseId/:pageRef?' component={CourseBodyPage} />
                    <Route path='/frontend/concept/:conceptId' exact component={ConceptPage} />
                    <Redirect to='/frontend/courseware/courseslist' />
                    <Route component={NotFound} />
                </Switch>)}
        {/* </React.Suspense> */}
    </Layout>
);
